export default __webpack_public_path__ + "static/media/roadmap.996cb340.png";